/*!
 * @monogrid/vue-boost v7.0.0-develop.3 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { computed as r } from "vue";
const n = (e) => {
  const t = e.attrs;
  return {
    component: r(() => t.to ? "router-link" : t.href ? "a" : t.tag && typeof t.tag == "string" ? t.tag : "button"),
    bindings: r(() => ({
      ...t,
      to: t.to,
      type: t.to || t.href || t.tag && t.tag !== "button" ? void 0 : t.type || "button"
    }))
  };
};
export {
  n as useCtaComponent
};
